import { InlineAlertType,InlineAlertWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { BrowserTitleService } from '../../../commonInfra/services/BrowserTitleService';
import { ProjectDefinition } from '../../../contentDefinitions/ProjectDefinition';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { PersonalSpaceInfo } from '../../../ts/restApi/personalSpace/PersonalSpace';
import { NullProjectIdForNonProjects,SpaceType } from '../../state/SpaceInfo';
import { ExplorerEmptyStateProps } from '../Components/ExplorerEmpyState';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { CreateContentButtonLocations, CreateContentButtonOwnProps } from '../Explorer/CreateContent/CreateContentButton';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { ContentSpecificControls } from '../Explorer/ExplorerToolbar';
import { createContentButton } from '../SubspaceHelpers';

const testIdPrefix = 'personal-space';
const EMPTY_STATE_TEST_ID = `${testIdPrefix}-empty-state`;

export interface PersonalSpaceOwnProps {
}

export interface PersonalSpaceStateProps {
  readonly contentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
  readonly defaultContentTypeFilterValues: ReadonlyArray<ExplorableItemType>;
  readonly personalSpace: PersonalSpaceInfo;
}

export interface PersonalSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly filterSelected: (selectedItems: ArrayLike<ExplorableItemType>) => void;
  readonly clearContentCounts: (spaceType: SpaceType) => void;
  readonly getPersonalSpace: () => void;
  readonly createNewWorkbook: (projectId?: string) => void;
}

export type PersonalSpaceProps = PersonalSpaceStateProps
  & PersonalSpaceDispatchProps
  & PersonalSpaceOwnProps;

export class PersonalSpace extends React.PureComponent<PersonalSpaceProps> {

  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.personalSpaceTitle() });
    this.props.requestSpaceContents();
    this.props.getPersonalSpace();
  }

  public render(): JSX.Element {
    const createContentButtonProps: CreateContentButtonOwnProps = {
      location: CreateContentButtonLocations.PersonalSpace,
      projectId: NullProjectIdForNonProjects,
      spaceType: 'personal'
    };
    const toolbarContentSpecificControlsProps: ContentSpecificControls = { beginning: this.props.personalSpace.readOnly ? undefined : createContentButton(createContentButtonProps)};
    return (
      <div className={SpaceContainerStyles.SpaceContainer}>
        <div className={SpaceContainerStyles.MastheadArea}>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.personalSpaceTitle()}</div>
          </div>
          <div style={SpaceContainerStyles.MastheadSubheadingArea}>
            {Messages.personalSpaceMastheadSubheading()}
          </div>
          {this.personalSpaceWarning(this.props.personalSpace.readOnly)}
        </div>
        <div className={SpaceContainerStyles.SubplaceArea}>
          <ConnectedExplorer
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              hideContentSpecificControlsInEmptyState: true,
              toolbarContentSpecificControls: toolbarContentSpecificControlsProps,
            }}
          />
        </div>
      </div>
    );
  }

  private personalSpaceWarning(readonly: boolean) {
    if (!readonly) {
      return null;
    }
    return (
      <InlineAlertWidget
        testId={'personalspace-warning'}
        type={InlineAlertType.Warning}
        style={{marginTop: '12px'}}
      >
        {Messages.personalSpaceReadOnlyWarning()}
      </InlineAlertWidget>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      primaryMessage: Messages.personalSpaceEmptyStatePrimary(),
      secondaryMessage: Messages.personalSpaceEmptyStateSecondary(),
      dataTestId: EMPTY_STATE_TEST_ID,
      actionButtonMessage: this.props.personalSpace.readOnly ? undefined : Messages.personalSpaceEmptyStateActionButton(),
      onActionButton: this.props.createNewWorkbook
    };
  }
}
